import { useSearchParams } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Box, Card, Flex, Text, Heading } from "@radix-ui/themes";

export default function SubscriptionSuccessPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const subscriptionId = searchParams.get("subscription_id");

  return (
    <Box
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--gray-2)",
        padding: "2rem",
      }}
    >
      <Card size="4" style={{ maxWidth: "600px", width: "100%" }}>
        <Flex direction="column" gap="6" align="center" p="6">
          <Box>
            <CheckCircle size={80} color="var(--green-9)" strokeWidth={1.5} />
          </Box>
          <Flex direction="column" gap="3" align="center">
            <Heading size="6" weight="bold">
              Subscription Activated!
            </Heading>
            <Text size="3" color="gray" align="center">
              Thank you for subscribing. Your subscription has been set up
              successfully and will be activated shortly.
            </Text>
          </Flex>
          {(sessionId || subscriptionId) && (
            <Card variant="surface" style={{ width: "100%" }}>
              <Flex direction="column" gap="3" p="4">
                <Text size="2" weight="bold" color="gray">
                  Transaction Details
                </Text>
                {sessionId && (
                  <Flex gap="2" align="center">
                    <Text size="2" color="gray">
                      Session ID:
                    </Text>
                    <Text size="2" style={{ fontFamily: "monospace" }}>
                      {sessionId}
                    </Text>
                  </Flex>
                )}
                {subscriptionId && (
                  <Flex gap="2" align="center">
                    <Text size="2" color="gray">
                      Subscription ID:
                    </Text>
                    <Text size="2" style={{ fontFamily: "monospace" }}>
                      {subscriptionId}
                    </Text>
                  </Flex>
                )}
              </Flex>
            </Card>
          )}
          <Text size="2" color="gray" align="center" mt="4">
            You can safely close this window.
          </Text>
        </Flex>
      </Card>
    </Box>
  );
}
